import { render, staticRenderFns } from "./shareMall.vue?vue&type=template&id=731f59c4&scoped=true"
import script from "./shareMall.vue?vue&type=script&lang=js"
export * from "./shareMall.vue?vue&type=script&lang=js"
import style0 from "./shareMall.vue?vue&type=style&index=0&id=731f59c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731f59c4",
  null
  
)

export default component.exports